import { Spinner } from "@/components/ui/v2/spinner";
import {
  CompanyDigitalIdEmployeesPage,
  CompanyDigitalIdLayout,
  CompanyDigitalIdSettingsPage,
} from "@/utils/lazyLoadComponents";
import type { RouteObject } from "react-router-dom";
import { redirect } from "react-router-dom";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import { MODULE_SETTINGS_PATHS } from "./module-settings.paths";

export enum COMPANY_DIGITAL_ID_PATH_SEGMENTS {
  ROOT = "digital-id",
  EMPLOYEES = "employees",
  // Module settings (moved out of Company Settings — was the "Digital ID
  // Card" tab there).
  // Literal, not `MODULE_SETTINGS_SEGMENT`: `isolatedModules` forbids enum
  // members initialized from an imported const. Keep both in sync.
  SETTINGS = "settings",
}

export const companyDigitalIdRoutes: RouteObject = {
  path: COMPANY_DIGITAL_ID_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Digital ID" },
  HydrateFallback: Spinner,
  children: [
    {
      Component: CompanyDigitalIdLayout,
      handle: { flushContent: true },
      children: [
        {
          index: true,
          loader: () => redirect(COMPANY_DIGITAL_ID_PATHS.EMPLOYEES),
        },
        {
          path: COMPANY_DIGITAL_ID_PATH_SEGMENTS.EMPLOYEES,
          handle: { breadcrumb: "Employees" },
          Component: CompanyDigitalIdEmployeesPage,
        },
      ],
    },

    // ── Module settings — a SIBLING of the tabs layout, never a child of it:
    // nesting it inside would render it under a tab bar with no matching tab.
    // Static "settings" also outranks the dynamic siblings in React Router's
    // route ranking, so there is no collision. ──────────────────────────────
    {
      path: COMPANY_DIGITAL_ID_PATH_SEGMENTS.SETTINGS,
      handle: { breadcrumb: "Settings", title: "Digital ID Settings" },
      Component: CompanyDigitalIdSettingsPage,
    },
  ],
};

export const COMPANY_DIGITAL_ID_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_DIGITAL_ID_PATH_SEGMENTS.ROOT)),
  EMPLOYEES: withCompanyPrefix(
    addSlashes(
      COMPANY_DIGITAL_ID_PATH_SEGMENTS.ROOT,
      COMPANY_DIGITAL_ID_PATH_SEGMENTS.EMPLOYEES,
    ),
  ),

  // ── Module settings (resolved in module-settings.paths.ts) ────────────────
  SETTINGS: MODULE_SETTINGS_PATHS.DIGITAL_ID.ROOT,
  SETTINGS_VTAB_BRAND_LOCK: MODULE_SETTINGS_PATHS.DIGITAL_ID.VTAB_BRAND_LOCK,
});
